import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import i18next from 'i18next';
import PropTypes from 'prop-types';

import './AssetPicker.scss';

class AssetPicker extends Component {
    imageUploaded(file) {
        this.props.onUpload(file);
    }

    render() {
        if (this.props.source) {
            if (this.props.video) {
                return (
                    <div className={`asset-picker image-preview video ${this.props.className}`}>
                        <video autoPlay muted loop>
                            <source src={this.props.source} type="video/mp4"></source>
                        </video>
                        <Button style={{ position: 'relative' }} icon="trash" floated="right" onClick={this.props.onDelete} />
                    </div>
                );
            }

            return (
                <div className={`asset-picker image-preview ${this.props.className}`} style={{ backgroundImage: `url(${this.props.source})` }}>
                    <Button icon="trash" floated="right" onClick={this.props.onDelete} />
                </div>
            );
        }

        return (
            <label className={`asset-picker input-label ${this.props.className}`}>
                <span className="plus-button">+</span>
                <div>{'Upload'}</div>
                <input
                    type="file"
                    className="input-file"
                    onChange={(e) => this.imageUploaded(e.target.files[0])}
                    accept={this.props.video ? 'video/mp4' : 'image/*'}
                />
            </label>
        );
    }
}

AssetPicker.propTypes = {
    className: PropTypes.string,
    source: PropTypes.string,
    video: PropTypes.bool,
    
    onUpload: PropTypes.func,
    onDelete: PropTypes.func
};

export default AssetPicker;
